import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrderItemModel } from 'src/app/models/order/order-item.model';
import { OrderModel } from 'src/app/models/order/order.model';
import { ApiService } from 'src/app/services/api.service';
import { BasePage } from '../base-page';
import { MessageService } from 'src/app/services/message.service';

@Component({
    selector: 'app-order-detail',
    templateUrl: './order-detail.component.html',
    styleUrls: ['./order-detail.component.scss'],
    standalone: false
})
export class OrderDetailComponent extends BasePage implements OnInit {

  public orderStatuses = [1, 2, 3, 4, 5];
  public paymentStatuses = [1, 2, 3, 4];

  public model?: OrderModel;

  constructor(private mApiService: ApiService, private mActivatedRoute: ActivatedRoute, private mMessageService: MessageService) {
    super();
  }

  ngOnInit(): void {
    this.mApiService.get<OrderModel>(`/api/admin/orders/${this.mActivatedRoute.snapshot.params['id']}`).subscribe({
      next: r => {
        r.utcDate += '+00:00';

        if (r.toTime) {
          r.toTime += '+00:00';
        }
        this.model = r;
        this.isBusy = false;
      }, error: () => this.isBusy = false
    });
  }

  public setOrderStatus() {
    if (!this.model) {
      return;
    }

    this.isBusy = true;
    this.mApiService.post<{}, {}>(`/api/admin/orders/${this.model.id}/status/${this.model.orderStatus}`, {}).subscribe({
      next: () => {
        this.mMessageService.addMessage({
          text: 'Статус заказа установлен',
          type: this.mMessageService.types.success
        }, true);
        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });

  }

  public setPaymentStatus() {
    if (!this.model) {
      return;
    }

    this.isBusy = true;
    this.mApiService.post<{}, {}>(`/api/admin/orders/${this.model.id}/payment/status/${this.model.paymentStatus}`, {}).subscribe({
      next: () => {
        this.mMessageService.addMessage({
          text: 'Статус оплаты установлен',
          type: this.mMessageService.types.success
        }, true);
        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }

  public getItemPrice(item: OrderItemModel) {
    return item.price + (item.modificators?.map(x => x.price * x.count).reduce((a, b) => a + b, 0) ?? 0);
  }
}
